import { restakingAccountAtom } from "@/atoms/restakingState"
import { refreshCounterRestakingAtom } from "@/atoms/settings"
import NotConnectWallet from "@/components/staking/components/detail/components/shared/NotConnectWallet"
import useRestaking from "@/hooks/useRestaking"
import { Container, Grid } from "@mui/material"
import "dayjs/locale/vi"
import { useAtomValue, useSetAtom } from "jotai"
import { useEffect } from "react"
import { useQuery } from "react-query"
import { MyStakingAssets } from "./components/myStakingAssets"
import { MyStakingRewards } from "./components/myStakingRewards"

const View = () => {
  const { address, fetchStakingAccountFn } = useRestaking()

  // atoms
  const refreshStakingCounter = useAtomValue(refreshCounterRestakingAtom)
  const setRestakingAccount = useSetAtom(restakingAccountAtom)

  // useQuery
  const { data: stakeAccountData } = useQuery(
    ["fetchStakeAccountFn", fetchStakingAccountFn, address, refreshStakingCounter],
    async () => {
      const stakeAccountResult = await fetchStakingAccountFn()
      if (stakeAccountResult.isSucceeded) {
        return stakeAccountResult.result
      }
      return null
    },
    {
      refetchOnWindowFocus: false,
    },
  )

  useEffect(() => {
    setRestakingAccount(stakeAccountData)
  }, [setRestakingAccount, stakeAccountData])

  if (!address) return <NotConnectWallet />

  return (
    <Container maxWidth='xl'>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <MyStakingAssets />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <MyStakingRewards />
        </Grid>
      </Grid>
    </Container>
  )
}

export default View
